import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const UpdatedContainer = styled("div")(() => ({
  display: "flex",
  maxWidth: "442px",
  width: "100%",
  padding: "40px",
  flexDirection: "column",
  alignItems: "center",
  gap: "40px",
  borderRadius: "4px",
  borderTop: `4px solid ${colors.brandBlue500}`,
  background: "#FFF",
  boxShadow: "0px 1px 3px 0px rgba(71, 84, 103, 0.30), 0px 4px 8px 3px rgba(71, 84, 103, 0.15)",
  "@media screen and (max-width: 442px)": {
    height: "100%",
    justifyContent: "center",
  },
}));

export const LogoImage = styled("img")(() => ({
  maxHeight: 80,
  maxWidth: 352,
  "@media screen and (max-width: 442px)": {
    maxWidth: 280,
  },
}));

export const UpdatedPasswordInfo = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "12px",
  width: "100%",
}));

export const UpdatedPasswordTitle = styled("span")(() => ({
  color: "#475467",
  textAlign: "center",
  font: "500 32px Manrope",
  lineHeight: "40px",
}));

export const UpdatedPasswordSubtitle = styled("span")(() => ({
  color: "#475467",
  textAlign: "center",
  font: "400 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const TextLink = styled("span")(() => ({
  font: "700 16px Manrope",
  color: colors.brandBlue500,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  whiteSpace: "nowrap",
  cursor: "pointer",
}));
